import { MoonLoader } from "react-spinners";

const LoadingItem = ({ isLoading, title }: any) => {
  return (
    <div className="h-full w-full flex justify-center items-center flex-col gap-2">
      <MoonLoader
        size={40}
        loading={isLoading}
        color="#D12E93"
        speedMultiplier={0.5}
      />
      <span className="font-semibold text-center mt-2 text-photo-time-pink-main">
        {title}
      </span>
    </div>
  );
};

export default LoadingItem;
